import React from 'react';

import './about.css';

const About = () => {
	return (
		<div className="about__content">
			<h1 className="gradient__text">About me</h1>
			<div/>
			<p>Pontianak, Indonesia
			<br/>
			<br/>
			Before this i'm use "Lorem Dipsum" to fill "about section" in my portfolio, because i dunno to describe my self.
			<br/>
			<br/>
			Many website about "how to" write self about i've been visit, but i'm little confuse to many force to fake for the looked nice, not to much but still exist fake person like that.
			<br/>
			<br/>
			And then, welcome and thanks you come here, let my projects to describe me to you about my profession and many skill - as Web Programmer.</p>
		</div>
	)
}

export default About;